export type SpaceshipInfoGridCellPresentation = "hidden" | "locked" | "defaultUnlocked" | "userUnlocked";

export function spaceshipInfoGridCellPresentation(
  gridMapChar: string,
  isUnlocked: boolean,
): SpaceshipInfoGridCellPresentation {
  if (gridMapChar === "#") return "hidden";
  if (!isUnlocked) return "locked";
  return gridMapChar === "L" ? "defaultUnlocked" : "userUnlocked";
}

/**
 * 설명 문자열에서 레벨 접두사("Lv1. " / "레벨 1. " 등)를 제거한다.
 * 원본 로컬라이제이션은 변경하지 않고 표시용으로만 사용한다.
 */
export function stripLevelPrefix(desc: string): string {
  return desc.replace(/^(?:Lv\.?\s*\d+|레벨\s*\d+)\.\s*/i, "");
}
